import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import axios from "axios";
import { setupAxios } from "./helpers/Utils";

import store from './store';

const app = (
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);

setupAxios(axios, store);

ReactDOM.render(app, document.getElementById('root'));
serviceWorker.unregister();
